/**
 * Core permission keys for the entire application.
 * These are shared across all user types (admin, manager, external user).
 */
export const CORE_PERMISSIONS = {
    // Dashboard permissions
    VIEW_BOOKING_DASHBOARD: 'VIEW_BOOKING_DASHBOARD',
    VIEW_SURVEY_DASHBOARD: 'VIEW_SURVEY_DASHBOARD',
    // User management permissions
    MANAGE_ADMINISTRATORS: 'MANAGE_ADMINISTRATORS',
    MANAGE_MANAGERS: 'MANAGE_MANAGERS',
    MANAGE_ACCESS_ROLES: 'MANAGE_ACCESS_ROLES',
    MANAGE_RECIPIENTS: 'MANAGE_RECIPIENTS',
    // Respondent permissions
    MANAGE_RESPONDENTS: 'MANAGE_RESPONDENTS',
    RESPONDENT_LIST: 'RESPONDENT_LIST',
    RESPONDENT_READ: 'RESPONDENT_READ',
    RESPONDENT_WRITE: 'RESPONDENT_WRITE',
    RESPONDENT_DOCUMENT_READ: 'RESPONDENT_DOCUMENT_READ',
    RESPONDENT_DOCUMENT_WRITE: 'RESPONDENT_DOCUMENT_WRITE',
    RESPONDENT_NOTE_READ: 'RESPONDENT_NOTE_READ',
    RESPONDENT_NOTE_WRITE: 'RESPONDENT_NOTE_WRITE',
    MANAGE_RESPONDENT_COMPANIES: 'MANAGE_RESPONDENT_COMPANIES',
    // Booking permissions
    MANAGE_BOOKINGS: 'MANAGE_BOOKINGS',
    BOOKING_READ: 'BOOKING_READ',
    BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS: 'BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS',
    BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS: 'BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS',
    BOOKING_WRITE: 'BOOKING_WRITE',
    BOOKING_CREATE_VIA_BOOKING_PAGE: 'BOOKING_CREATE_VIA_BOOKING_PAGE',
    BOOKING_CREATE_VIA_CALENDAR: 'BOOKING_CREATE_VIA_CALENDAR',
    EVENT_CREATE_VIA_CALENDAR: 'EVENT_CREATE_VIA_CALENDAR',
    BOOKING_DOCUMENT_READ: 'BOOKING_DOCUMENT_READ',
    BOOKING_DOCUMENT_WRITE: 'BOOKING_DOCUMENT_WRITE',
    BOOKING_CALENDAR_READ: 'BOOKING_CALENDAR_READ',
    MANAGE_BOOKING_COMPANIES: 'MANAGE_BOOKING_COMPANIES',
    MANAGE_CONFIRMATION_TEXT: 'MANAGE_CONFIRMATION_TEXT',
    MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES: 'MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES',
    MANAGE_BOOKING_PAGE_COMPANIES: 'MANAGE_BOOKING_PAGE_COMPANIES',
    // Survey permissions
    MANAGE_SURVEY_TYPES: 'MANAGE_SURVEY_TYPES',
    MANAGE_SURVEY_BACKGROUNDS: 'MANAGE_SURVEY_BACKGROUNDS',
    SURVEY_READ: 'SURVEY_READ',
    SURVEY_WRITE: 'SURVEY_WRITE',
    SURVEY_COMPLETED_SEND: 'SURVEY_COMPLETED_SEND',
    VIEW_REPORTS: 'VIEW_REPORTS',
    VIEW_FLAGGED_QUESTIONS: 'VIEW_FLAGGED_QUESTIONS',
    // Sales and Invoicing permissions
    CONFIGURE_SALES_AND_INVOICING: 'CONFIGURE_SALES_AND_INVOICING',
    MANAGE_SALES_INVOICE_CONFIG: 'MANAGE_SALES_INVOICE_CONFIG',
    MANAGE_TAX_RATES: 'MANAGE_TAX_RATES',
    MANAGE_ITEMS: 'MANAGE_ITEMS',
    MANAGE_SERVICE_SURVEY_ITEMS_CONFIG: 'MANAGE_SERVICE_SURVEY_ITEMS_CONFIG',
    MANAGE_BOOKING_PAGE_PAYMENT_CONFIG: 'MANAGE_BOOKING_PAGE_PAYMENT_CONFIG',
    INVOICES_AND_PAYMENTS: 'INVOICES_AND_PAYMENTS',
    VIEW_ALL_INVOICES: 'VIEW_ALL_INVOICES',
    CREATE_INVOICES: 'CREATE_INVOICES',
    EDIT_INVOICES: 'EDIT_INVOICES',
    CHANGE_INVOICE_PAYMENT_STATUS: 'CHANGE_INVOICE_PAYMENT_STATUS',
    EXPORT_SEND_INVOICES: 'EXPORT_SEND_INVOICES',
    MANAGE_ADD_ON_CHARGES: 'MANAGE_ADD_ON_CHARGES',
    VIEW_PAYMENT_TRANSACTION: 'VIEW_PAYMENT_TRANSACTION',
    // Other permissions
    MANAGE_APP_CONFIGURATIONS: 'MANAGE_APP_CONFIGURATIONS',
    MANAGE_API: 'MANAGE_API',
    MANAGE_BILLING: 'MANAGE_BILLING',
    MANAGE_COMPANIES: 'MANAGE_COMPANIES',
};
//# sourceMappingURL=corePermissionKeys.js.map